import { Box, Typography } from "@mui/material";
// import SearchBar from "Components/shared/SearchBar";
// import CustomDateField from "Components/shared/CustomDateField";
import DropdownMenu from "Components/shared/DropdownMenu";
import CustomButton from "Components/shared/Button";
import { useState, useEffect } from "react";
import { orderStatus, OrderTypeEnum } from "enums/shared";
import { useRTL } from "hooks/isRTL";
import { RefreshButton } from "Components/shared/RefreshButton";
import formatTime from "utils/formatTime";
import ExportButton from "Components/shared/ExportButton";

/**
 * A search and filter component for the order table.
 *
 * @param {Object} props - The component props.
 * @param {function(Object):void} props.fetchDataHandler - Callback to update parent filters.
 * @param {number} [props.lastUpdated] - timestamp passed from OrderTable on data fetch.
 * @returns {JSX.Element} The rendered OrderSearch component.
 */
const OrderSearch = ({
  fetchDataHandler,
  initialFilters,
  lastUpdated: parentLastUpdated,
}) => {
  const { t } = useRTL();

  const normalizedStatus = initialFilters?.status // mark
    ? Object.entries(orderStatus).find(
        ([key, value]) =>
          String(key) === String(initialFilters.status) || //convert the numric to string to display
          value.value === initialFilters.status
      )?.[0]
    : null;

  const [filters, setFilters] = useState(() => ({
    searchBar: "",
    fromDate: null,
    toDate: null,
    status: normalizedStatus,
    orderType: null,
    ...initialFilters,
  }));

  const [localLastUpdated, setLocalLastUpdated] = useState(
    parentLastUpdated || Date.now()
  );

  useEffect(() => {
    if (parentLastUpdated) {
      setLocalLastUpdated(parentLastUpdated);
    }
  }, [parentLastUpdated]);

  // const statusOptions = Object.entries(orderStatus).map(([key, value]) => ({
  //   value: Number(key),
  //   label: t(value.value),
  // }));

  // const orderTypeOptions = [
  //   { value: "regular", label: t("regular") },
  //   { value: "expedited", label: t("expedited") },
  // ];

  /**
   * Merges new filter values with the existing filters and updates the state.
   * Triggers data-fetching handler with the updated filters.
   * Which will effect the order.js service
   *
   *
   * @param {Object} newFilters - The new filter values to apply.
   * @param {string} [newFilters.searchBar] - The search text.
   * @param {Date|null} [newFilters.fromDate] - The start date filter.
   * @param {Date|null} [newFilters.toDate] - The end date filter.
   * @param {string|null} [newFilters.status] - The status filter value.
   * @returns {void}
   */
  const updateFilters = (newFilters) => {
    const updatedFilters = { ...filters, ...newFilters };
    setFilters(updatedFilters);
    fetchDataHandler(updatedFilters);
  };

  // const handleSearchChange = (searchValue) => {
  //   updateFilters({ searchBar: searchValue });
  // };

  // const handleDateChange = (key, date) => {
  //   const updatedFilters = { ...filters, [key]: date };
  //   setFilters(updatedFilters);
  //   if (updatedFilters.fromDate && updatedFilters.toDate) {
  //     fetchDataHandler(updatedFilters);
  //   }
  // };

  // const handleDropdownChange = (value) => {
  //   updateFilters({ status: value });
  // };

  const handleClearFilters = () => {
    const clearedFilters = {
      searchBar: "",
      fromDate: null,
      toDate: null,
      status: null,
      orderType: null,
      senderName: "",
      orderNumber: null,
      receiverName: "",
      driverName: "",
      sortDescending: true,
      pickupDate: null,
      dropoffDate: null,
      creationDate: null,
      pickUpLocation: "",
      dropOffLocation: "",
    };
    setFilters(clearedFilters);
    fetchDataHandler(clearedFilters);
    setLocalLastUpdated(Date.now());
  };

  const handleRefresh = () => {
    const now = Date.now();
    setLocalLastUpdated(now);
    updateFilters({ refreshKey: now });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: "16px",
        backgroundColor: "background.default",
        padding: "16px",
        borderRadius: "8px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {/* <SearchBar value={filters.searchBar} onSearch={handleSearchChange} /> */}

        <CustomButton onClick={handleClearFilters}>
          {t("clearFilters")}
        </CustomButton>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
            alignItems: "center",
            backgroundColor: "background.gray",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
          }}
        >
          <Typography variant="body2" fontWeight="bold" color="text.black">
            {t("updated")}:
          </Typography>
          <Typography variant="body2" color="text.black">
            {formatTime(localLastUpdated)}
          </Typography>
        </Box>

        <DropdownMenu
          placeholder={t("orderType")}
          options={[
            { value: OrderTypeEnum.regular, label: t("regular") },
            { value: OrderTypeEnum.expedited, label: t("expedited") },
          ]}
          onChange={(value) => updateFilters({ orderType: value === "" ? null : value })}
          value={filters.orderType ?? ""}
        />

        <RefreshButton onClick={handleRefresh}>{t("refresh")}</RefreshButton>
        <ExportButton reportType="orderlist" />

        {/* <CustomDateField
          value={filters.fromDate}
          onChange={(date) => handleDateChange("fromDate", date)}
          placeholder={t("from")}
        />
        <CustomDateField
          value={filters.toDate}
          onChange={(date) => handleDateChange("toDate", date)}
          placeholder={t("to")}
        /> */}
        {/* <DropdownMenu
          value={filters.status}
          placeholder={t("status")}
          options={statusOptions}
          onChange={handleDropdownChange}
        /> */}
      </Box>
    </Box>
  );
};

export default OrderSearch;
